define('SageDotCom/Components/ProductCard',["jquery",
    "eventManager",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/Components/ProductCardAlignment",
    "SageDotCom/DataLayer/Events/bodySelect",
    "SageDotCom/DataLayer/Events/product-card-detail"],
    function ($, eventManager, tealium, ProductCardAlignment, bodySelectEvent, ProductCardDetailEvent) {
        var firstLoad = true;
        var isEditor = $('[class*="experience-editor"]').length >= 1;

        function ProductCard(args) {
            var scope = args.scope;

            if (args.Product) {
                addProductToPageDataAnalytics(scope, "pageview", "", false, JSON.parse(args.Product), "");
                setProductCardBuyButtonWithModalHref(scope);
            }

            //<summary>Initialize a new instance of FlexBox. Subscribe to messages which are passed to current instance.</summary>
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

            var eventName = 'productCardPriceChange:' + $(scope)[0].id;

            htmlDecode = function (value) {
                return $("<textarea/>").html(value).text();
            }

            if ($(scope).find("> .horizontal-card").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("has-horizontal-card");
            }

            if ($(scope).find("> .brilliant-green-outline").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("brilliant-green-outline");
            }
            if ($(scope).find("> .inner-shadow").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("inner-shadow");
                $(scope).parent(".sage-product-card-outer")
                    .prepend("<div class='sage-product-card-outer-background'></div>");
            }
            if ($(scope).find("> .over-dark-transparent").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("over-dark-transparent");
            }
            if ($(scope).find("> .promo-header-full-width").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("promo-header-full-width");
            }
            if ($(scope).find("> .jade-t7-40").length > 0) {
                $(scope).parent(".sage-product-card-outer").addClass("jade-t7-40");
            }

            //subscript to price change
            eventManager.subscribe(eventName, function (prodCard) {

                var pid = $(prodCard).find('.sage-product-card,.sage-product-card-alt').attr('data-pid');

                //collect values from product card selectors to determine prices
                var external = $(prodCard).attr('data-external-selector');
                var dropdown = $(prodCard).find('select.price-ddl').find('option:selected').val();
                var checkbox = $(prodCard).find('input.addon-chk');
                var addon = "";
                var checkBoxParent = $(checkbox).parents(".sage-product-card-addon-alt");
                var isAnAltCard = checkBoxParent !== undefined && checkBoxParent.length > 0;
                var allcheckboxes = "";
                if (isAnAltCard) {
                    allcheckboxes = $(checkBoxParent).parent();
                } else {
                    //for old style addon checkbox
                    allcheckboxes = $(checkbox).parent().parent();
                }
                if (allcheckboxes !== undefined) {
                    for (let i = 0; i < allcheckboxes.length; i++) {
                        if ($(allcheckboxes[i]).css("display") === "block") {
                            addon = $(checkbox[i]).prop('checked') ? "addon" : "";
                            break;
                        }
                    };
                    for (let i = 0; i < allcheckboxes.length; i++) {
                        if ($(allcheckboxes[i]).css("display") !== "block") {
                            var addonTemp = $(checkbox[i]).prop('checked') ? "addon" : "";
                            if (addon !== addonTemp) {
                                $(checkbox[i]).prop("checked", !$(checkbox[i]).prop("checked"));
                            }
                            break;
                        }
                    };
                }
                var hasDropdown = true;
                firstLoad = false;

                if (external == undefined || external == "") {
                    external = "product card 1st option";
                }

                if (dropdown == undefined || dropdown == null) {
                    dropdown = "";
                    hasDropdown = false;

                    //if there are other product cards on the page with dropdown available, get from there the selected value.
                    if ($(".sage-product-card[data-pid='" + pid + "'],.sage-product-card-alt[data-pid='" + pid + "']").length > 1) {
                        $(".sage-product-card[data-pid='" + pid + "'],.sage-product-card-alt[data-pid='" + pid + "']").each(function (i, otherProductCard) {
                            if ($(otherProductCard).closest('.comparison-table-product-card.clone').length == 0) {
                                var dropdownInOtherProductCard = $(otherProductCard).find('select.price-ddl').find('option:selected').val();
                                if (dropdownInOtherProductCard != undefined && dropdownInOtherProductCard != null && dropdownInOtherProductCard != "") {
                                    dropdown = dropdownInOtherProductCard;
                                    hasDropdown = true;
                                }
                            }
                        });
                    }
                }

                if (addon == undefined || addon == null || addon == "") {
                    addon = "";
                    //if there are other product cards on the page with a addon check box available, get from there the selected value.
                    if ($(".sage-product-card[data-pid='" + pid + "'],.sage-product-card-alt[data-pid='" + pid + "']").length > 1) {
                        $(".sage-product-card[data-pid='" + pid + "'],.sage-product-card-alt[data-pid='" + pid + "']").each(function (i, otherProductCard) {
                            if ($(otherProductCard).closest('.comparison-table-product-card.clone').length == 0) {
                                var addonInOtherProductCard = $(otherProductCard).find('input.addon-chk').prop('checked') ? "addon" : "";
                                if (addonInOtherProductCard != undefined && addonInOtherProductCard != null && addonInOtherProductCard != "") {
                                    addon = addonInOtherProductCard;
                                }
                            }
                        });
                    }
                }

                $(".sage-product-card[data-pid='" + pid + "'],.sage-product-card-alt[data-pid='" + pid + "']").each(function (i, itemPC) {

                    //get parent as this snippet contains the main .sage-product-card.
                    productCardToChange = $(itemPC).parent();
               

                    //all html elements with 'variances' which are the options to display. See product, price and addon templates
                    $(productCardToChange).find('*[data-pd-variances]').each(function (i, item) {
                        $($(item).data('pd-variances')).each(function (k, kitem) {

                            var selAddon = kitem[0];
                            var selDropdown = kitem[1];
                            var selExternal = kitem[2];
                            var selValue = kitem[3];

                            //in case there is no dropdown into the component, disconsider its value
                            if (!hasDropdown) {
                                selDropdown = "";
                            } else {
                                //guarantee that the select is visible if it exists.
                                $(prodCard).find('select.price-ddl').show();
                            }

                            //if it found a suitable value, use it
                            if (selAddon == addon && selDropdown == dropdown && selExternal == external) {
                                $(item).html(htmlDecode(selValue));
                            }

                            //cases where there is one external switcher without the dropdown while the product card has the dropdown. ex. page: /de-de/produkte/sage-50-buchhaltungssoftware/
                            else {

                                if (hasDropdown) {

                                    //skipt the first which represents the product and not the price option
                                    if (i != 0) {
                                        //check 
                                        if (selAddon == addon && selExternal == external && selDropdown == "") {

                                            //verify if that is the only value available for that setting 
                                            var onlyOne = true;
                                            $($(item).data('pd-variances')).each(function (w, witem) {
                                                var w_selAddon = witem[0];
                                                var w_selDropdown = witem[1];
                                                var w_selExternal = witem[2];

                                                if (w != k && w_selAddon == addon && w_selExternal == external && w_selDropdown == "") {
                                                    onlyOne = false;
                                                }
                                            });

                                            if (onlyOne) {
                                                //set the value
                                                $(item).html(htmlDecode(selValue));

                                                //hide the product card price selector as this price option don`t need one.
                                                $(prodCard).find('select.price-ddl:not(.dynamic-select)').hide();
                                            }
                                        }
                                    }
                                }
                            }

                        });
                    });

                    //variances for button, where the url changes
                    $(productCardToChange).find('*[data-pd-url-variances]').each(function (i, item) {
                        $($(item).data('pd-url-variances')).each(function (k, kitem) {

                            var selAddon = kitem[0];
                            var selDropdown = kitem[1];
                            var selExternal = kitem[2];
                            var selValue = kitem[3];
                            var selText = kitem[4];

                            //in case there is no dropdown into the component, disconsider its value
                            if (!hasDropdown) {
                                selDropdown = "";
                            }

                            //in cases where the ddl is hidden in the product card, so don`t consider the value collected before it was hidden
                            var dropdownToCompare = dropdown;
                            if (!$(prodCard).find('select.price-ddl').is(':visible')) {
                                dropdownToCompare = "";
                            }

                            if (selAddon == addon && selDropdown == dropdownToCompare && selExternal == external) {
                                if (selText !== "") {
                                    item.querySelector('a').innerHTML = selText;
                                }

                                if (selValue === "") {
                                    $(item).find('a').hide();
                                } else {
                                    $(item).find('a').show();
                                }

                                $(item).find('a:not(.multi-step-panel-next-step-btn, .dynamic-product-card-modal-launch-btn)').attr('href', unescape(selValue));
                                eventManager.trigger("loadUtmParams");
                            }
                        });
                    });
                });

                var priceDropdown = $(prodCard).find('select')[0];
                triggerBodySelectionTealiumEvent(priceDropdown);

                loadTooltip();
            });

            //allow n options for CCF message selection based on the select index
            eventManager.subscribe('product card 1st option', function (e) {
                switchSecondary(e);
                $(scope).attr('data-external-selector', 'product card 1st option');
                if (!$(scope).closest(".comparison-table-product-card").hasClass("clone")) {
                    eventManager.trigger(eventName, $(scope));
                }
                loadTooltip();

                ProductCardAlignment.refreshProductCardHeights();
            });

            eventManager.subscribe('product card 2nd option', function (e) {
                switchSecondary(e);
                $(scope).attr('data-external-selector', 'product card 2nd option');
                if (!$(scope).closest(".comparison-table-product-card").hasClass("clone")) {
                    eventManager.trigger(eventName, $(scope));
                }
                loadTooltip();
                ProductCardAlignment.refreshProductCardHeights();
            });

            eventManager.subscribe('product card 3rd option', function (e) {
                switchSecondary(e);
                $(scope).attr('data-external-selector', 'product card 3rd option');
                if (!$(scope).closest(".comparison-table-product-card").hasClass("clone")) {
                    eventManager.trigger(eventName, $(scope));
                }
                loadTooltip();

                ProductCardAlignment.refreshProductCardHeights();
            });

            eventManager.subscribe('product card 4th option', function (e) {
                switchSecondary(e);
                $(scope).attr('data-external-selector', 'product card 4th option');
                if (!$(scope).closest(".comparison-table-product-card").hasClass("clone")) {
                    eventManager.trigger(eventName, $(scope));
                }
                loadTooltip();

                ProductCardAlignment.refreshProductCardHeights();
            });

            eventManager.subscribe('product card detail event', function (trigger, productCardUrl, isCrossSell, productName, dropDownIndex) {
                addProductToPageDataAnalytics(scope, trigger, productCardUrl, isCrossSell, JSON.parse(args.Product), productName, dropDownIndex);
            });

        }

        var destroyTooltipTimeout = undefined;
        function destroyTooltip() {
            clearTimeout(destroyTooltipTimeout);
            destroyTooltipTimeout = setTimeout(function () {
                $('.sage-product-card-tooltip-icon').each(function () {
                    $(this).tooltip('destroy');
                });
            }, 10);
        }

        var loadTooltipTimeout = undefined;
        function loadTooltip() {
            clearTimeout(loadTooltipTimeout);
            loadTooltipTimeout = setTimeout(function () {
                $('.sage-product-card-tooltip tr').each(function () {
                    if ($(this).find('span').is(':empty')) {
                        $(this).css('display', 'none');
                    } else {
                        $(this).css('display', '');
                    }
                });

                $('.sage-product-card-tooltip-icon').each(function () {
                    $(this).tooltip(
                        {
                            html: true,
                            placement: 'bottom',
                            container: 'body',
                            title: $('#' + $(this).data('tip')).html()
                        });
                });
            }, 500);
        }

        switchSecondary = function (obj) {
            destroyTooltip();

            var inactive = "secondary";
            firstLoad = false;
            if (!obj)
                return;

            if (!obj.scope)
                return;

            var e = obj.scope;

            //return if click in the inactive
            if ($(e).attr('class').indexOf(inactive) < 0)
                return;

            //storage
            var oldClass = $(e).attr('class');

            //find a different class in the siblings to be applied
            var newClass = $(e).attr('class');
            $(e).parent().children('a').each(function (i, item) {
                if ($(e).attr('class') != $(item).attr('class')) {
                    newClass = $(item).attr('class');
                }
            });

            $(e).attr('class', newClass);

            //mark the siblings to be inactive
            $(e).parent().children('a').each(function (i, item) {
                if ($(e).attr('id') != $(item).attr('id')) {
                    $(item).attr('class', oldClass);
                }
            });
        }

        ProductCard.init = function init(args) {
            return args.IsEditorEditing
                ? null
                : new ProductCard(args);
        };

        function addProductToPageDataAnalytics(scope, trigger, productCardUrl, isCrossSell, product, productName, dropDownIndex) {
            const productService = new ProductCardDetailEvent();
            var productCardElements = $(".score-button.product-card-cta-alt.product-card-cta-primary-alt:visible", scope);
            var sku = "", originalSku = "", locale = "", promoCode = "";

            if (isCrossSell && product.title !== productName) return;

            if (productCardElements.length <= 0) {
                productCardElements = $(".score-button.product-card-cta-alt.product-card-cta-secondary-alt:visible", scope);
            }

            if (productCardElements.hasClass("modal-launch-btn") && productCardElements.length <= 0) {
                productCardElements = $(".score-button.product-card-cta-alt.product-card-cta-primary-alt:not(.modal-launch-btn)", scope);

                if (productCardElements.length <= 0) {
                    productCardElements = $(".score-button.product-card-cta-alt.product-card-cta-secondary-alt:not(.modal-launch-btn)", scope);
                }
            }

            if (productCardElements.length > 0) {
                //Get variables to send to product service for product info
                let attr = productCardElements.hasClass("multi-step-panel-next-step-btn") || productCardElements.hasClass("dynamic-product-card-modal-launch-btn") ? "data-href" : "href";
                productCardUrl = productCardUrl !== "" ? productCardUrl : productCardElements.attr(attr);
                productCardUrl = productService.parseURL(productCardUrl);
                productCardUrl = productCardUrl.substring(1);
                const slashIndex = productCardUrl.indexOf("/");
                locale = productCardUrl.substring(0, slashIndex);
                sku = productService.parseUrlData(productCardUrl, "sku");
                originalSku = productService.parseUrlData(product.buyUrl, "sku");
                promoCode = productService.parseUrlData(productCardUrl, "promoCode");
            }

            const relatedProductIdentifier = `RelatedProductInfo${sku}${locale}`;
            const storedRelatedProductInfo = document.getElementById(
                relatedProductIdentifier
            );
            let isRelatedProductStored = false;
            try {
                if (
                    storedRelatedProductInfo !== null &&
                    storedRelatedProductInfo !== undefined
                ) {
                    isRelatedProductStored = true;
                    const storedRelatedProductResult = storedRelatedProductInfo.text;
                    if (!storedRelatedProductResult) {
                        isRelatedProductStored = false;
                    } else {
                        productService.populateDetailEvent(
                            JSON.parse(storedRelatedProductResult),
                            originalSku,
                            trigger,
                            isCrossSell
                        );
                    }
                }
            } catch (errorParse) {
                console.error(errorParse);
            } finally {
                if (!isRelatedProductStored) {
                    $.when(
                        productService.productDetailEvent(
                            sku,
                            originalSku,
                            promoCode,
                            locale,
                            trigger,
                            isCrossSell
                        )
                    );
                }
            }
        }

        function triggerBodySelectionTealiumEvent(select) {
            if (select) {
                var data = bodySelectEvent.GenerateEventMetadata(select);
                data.event_label = select.value;
                tealium.event(data);
            }
        }

        //for Modal of product card: set the opening button href
        function setProductCardBuyButtonWithModalHref(scope) {
            var productCardPrimaryCta = $(".score-button.product-card-cta-alt.product-card-cta-primary-alt", scope);
            if (productCardPrimaryCta.length > 0) {
                var href = productCardPrimaryCta.attr("href");
                if (href == null || href == "")
                    return;
                var productCardButtonWithModal = $(".score-button.modal-launch-btn", scope);
                if (productCardButtonWithModal.length > 0) {
                    productCardButtonWithModal.attr("href", href);
                }
            }
        }

        if (firstLoad && !isEditor) {
            ProductCardAlignment.init();
            eventManager.trigger("product card 1st option");
        }

        return ProductCard;
    });

